import { parse } from './query-string';


export default function getQueryParams(url) {
  if (!url) {
    return {};
  }
  const query = url.match(/(?:\?|$)([^#]*)/)[1];
  return parse(query);
}



// WEBPACK FOOTER //
// ./src/shared/utils/get-query-params.js